export const environment = {
  production: false,
 
     ////////////////////////////////////////////////////////////////

            /////////////  api hosted locally //////////////////
           // apiUrl: 'http://localhost:63601/api'

         ////////////////   api application in debug mode ////////////
         ///    apiUrl: 'http://localhost:44390/api'
    

      ///////////////////  api in live in client machine ////////////////
        apiUrl: 'https://api.collegecampusonline.com/api'



};
